import { render, staticRenderFns } from "./YearWheelEditor.vue?vue&type=template&id=5963d9c8&scoped=true&"
import script from "./YearWheelEditor.vue?vue&type=script&lang=ts&"
export * from "./YearWheelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./YearWheelEditor.vue?vue&type=style&index=0&id=5963d9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963d9c8",
  null
  
)

export default component.exports